<div [id]="getId()" class="modal fade" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button aria-hidden="true" class="btn-close" data-bs-dismiss="modal" title="Schließen"
                        type="button"></button>
            </div>
            <div class="modal-body">
                <p>
                    <strong>Für diese Funktion brauchst du eine funktionierende Internetverbindung.</strong>
                </p>
            </div>
        </div>
    </div>
</div>